<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vii"></a>CONTENTS</p>
<p class="toct"><a href="#/html/9780226905693_06_ack#ack">Acknowledgments</a></p>
<p class="toca"><a href="#/html/9780226905693_07_ch1#ch1"><strong>ONE:</strong> In Hock</a></p>
<p class="toc"><a href="#/html/9780226905693_08_ch2#ch2"><strong>TWO:</strong> The “Jew Broker” in American Culture</a></p>
<p class="toc"><span href="#/html/9780226905693_09_ch3#ch3" title="Link target outside of Sample"><strong>THREE:</strong> In Defense of Pawnbrokers</span></p>
<p class="toc"><span href="#/html/9780226905693_10_ch4#ch4" title="Link target outside of Sample"><strong>FOUR:</strong> The Economies of Everyday Life</span></p>
<p class="toc"><span href="#/html/9780226905693_11_ch5#ch5" title="Link target outside of Sample"><strong>FIVE:</strong> Pawnbroking and Criminal Activity</span></p>
<p class="toc"><span href="#/html/9780226905693_12_ch6#ch6" title="Link target outside of Sample"><strong>SIX:</strong> Loan Societies and the Legitimation of Pawnbroking</span></p>
<p class="toc"><span href="#/html/9780226905693_13_ch7#ch7" title="Link target outside of Sample"><strong>SEVEN:</strong> Unredeemed</span></p>
<p class="tocb"><span href="#/html/9780226905693_14_not#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/html/9780226905693_15_ind#ind" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226905693_05_toc.vue?4f40503b